import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IClientCustomer } from 'src/app/core/interfaces/onboarding/customer-portfolio/client-customer.interface';
import { ICustomerPortfolio } from 'src/app/core/interfaces/onboarding/customer-portfolio/customer-portfolio.interface';
import { PageState } from 'src/app/core/models/page-state/page-state.model';
import { HydrationService } from 'src/app/core/services/login/hydration.service';
import { CustomerPortfolioService } from 'src/app/core/services/onboarding/customer-portfolio.service';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import * as CustomerPortfolioActions from 'src/app/core/store/onboarding/actions/customer-portfolio.actions';

@Component({
  selector: 'app-customer-portfolio-table',
  templateUrl: './customer-portfolio-table.component.html',
  styleUrls: ['./customer-portfolio-table.component.scss'],
})
export class CustomerPortfolioTableComponent implements OnInit {
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  @Input() editCustomer: () => Promise<unknown>;
  @Input() additionalCreditInfoState: PageState;
  data: IClientCustomer[];
  payload: ICustomerPortfolio;
  customerDetails: IClientCustomer[];
  griddata: Promise<IClientCustomer[]>;
  isLoading: boolean;

  constructor(
    private cp: CustomerPortfolioService,
    private hs: HydrationService,
    private store: Store<IAppState>,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    // await this.cp.getGridCustomerData().then((result: IClientCustomer[]) => {
    //   this.isLoading = true;
    //   this.data = result;
    //   this.isLoading = false;
    //
    // });
    this.data = await this.cp.getGridCustomerData();
    this.isLoading = false;
  }

  async deleteCustomer(id: string) {
    this.isLoading = true;
    const customerData = await this.cp.deleteCustomerInfo(id);
    this.outputParameter.emit(customerData);
    this.cp.getGridCustomerData().then((result: IClientCustomer[]) => {
      this.isLoading = true;
      this.data = result;
      this.isLoading = false;
    });
    this.isLoading = false;
  }

  async gotoEditCustomer(clientCustomerId: number) {
    const hydratedData = await this.hs.HydrateCustomerPortfolioStore(
      clientCustomerId
    );
    this.payload = this.cp.getPayload();
    if (hydratedData) {
      this.editCustomer();
    }
  }

  async goToAdditionalCreditInfo(
    clientCustomerId: number,
    customerName: string
  ): Promise<unknown> {
    this.store.dispatch(
      CustomerPortfolioActions.CustomerNameAndIdAction({
        clientCustomerId: clientCustomerId.toString(),
        customerName,
      })
    );
    this.router.navigate([this.additionalCreditInfoState.pageUrl], {
      queryParams: { stateId: this.additionalCreditInfoState.id },
    });
    return true;
  }
}
